import { create } from 'zustand';
import {AnalyticsStore, IPreviewAnalytic} from "../types/analytics";
import {IEnrichedMetadata} from "../types/metadata";

const useAnalyticsStore = create<AnalyticsStore>((set) => ({
  previewAnalytics: [],
  setPreviewAnalytics: (analytics: IPreviewAnalytic[]) => set({ previewAnalytics: analytics }),

  enrichedMetadata: [],
  setEnrichedMetadata: (enrichedMetadata: IEnrichedMetadata[]) => set({ enrichedMetadata: enrichedMetadata }),
}));

export default useAnalyticsStore;
